import { BackendService } from './BackendService';
const TOKEN_KEY = 'token';
const MFA_TOKEN_KEY = 'mfaSessionToken';

export default class AuthService {
  static setToken(token: string | null) {
    return token == null
      ? localStorage.removeItem(TOKEN_KEY)
      : localStorage.setItem(TOKEN_KEY, token);
  }

  static getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  static isLoggedIn() {
    return !!AuthService.getToken();
  }
  static logout() {
    return BackendService.post('/users/logout');
  }

  static getMfaSessionToken = () => localStorage.getItem(MFA_TOKEN_KEY);
  static setMfaSessionToken = (token: string | null) =>
    token
      ? localStorage.setItem(MFA_TOKEN_KEY, token)
      : localStorage.removeItem(MFA_TOKEN_KEY);
}
